export const periods = {
    state: {
        periods: [
            {
                id: 0,
                name: 'Jednorazowo'
            }, {
                id: 1,
                name: 'Co dwa tygodnie'
            }, {
                id: 2,
                name: 'Raz w miesiącu'
            }
        ]
    },
    getters: {
        periods: (state) => {
            return state.periods
        },
        periodById: (state) => (id) => {
            return state.periods.find(item => item.id === id)
        }
    }
}
